import { render, staticRenderFns } from "./FormFiles.vue?vue&type=template&id=9b24ed22&"
import script from "./FormFiles.vue?vue&type=script&lang=js&"
export * from "./FormFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports